import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'

export const LegalLinks = () => {
  const staticBlockID = CMS_BLOCK.FOOTER_LEGAL
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false

  })

  return (
    <Container>
      {staticBlock.content && (
        <div
          dangerouslySetInnerHTML={{
            __html: staticBlock.content
          }}
        />
      )}
    </Container>
  )
}
